import { render, staticRenderFns } from "./TopCartProduct.vue?vue&type=template&id=1c56856b"
import script from "./TopCartProduct.vue?vue&type=script&lang=ts"
export * from "./TopCartProduct.vue?vue&type=script&lang=ts"
import style0 from "./TopCartProduct.vue?vue&type=style&index=0&id=1c56856b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports